import { ELeaveContactsActions } from '../../constants/actionTypes/leaveContactsModal';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const openLeaveContactsModal = actionGenerator<ELeaveContactsActions.open>(ELeaveContactsActions.open);
export const closeLeaveContactsModal = actionGenerator<ELeaveContactsActions.close>(ELeaveContactsActions.close);

export type TOpenLeaveContactsModalAction = ReturnType<typeof openLeaveContactsModal>;
export type TCloseLeaveContactsModalAction = ReturnType<typeof closeLeaveContactsModal>;

export type TLeaceContactsActions = TOpenLeaveContactsModalAction | TCloseLeaveContactsModalAction;
